import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { RoleService } from '../../../service/role.service';
import { RoleState } from '../../../store/Role/RoleReducer';
import { PermissionDto, RoleDto } from '@clearing-hub/common';
import { UpdateRole } from '../../../store/Role/RoleActions';
import { initPermissionSelector } from '../../../store/Role/RoleSelector';
import { UpdateRoleForm } from '../../../model/UpdateRoleForm';
import { UpdateRoleCommand } from '@clearing-hub/command';

@Component({
  selector: 'fxch-update-role',
  templateUrl: './update-role.component.html',
  styleUrls: ['./update-role.component.scss']
})
export class UpdateRoleComponent implements OnInit, OnDestroy {

  private subscriptions: Array<Subscription> = new Array<Subscription>();

  roleForm: FormGroup<UpdateRoleForm>;
  role: RoleDto;
  permissions: Array<PermissionDto>;

  constructor(private readonly fb: FormBuilder,
              private readonly modalRef: BsModalRef,
              private readonly roleService: RoleService,
              private readonly roleStore: Store<RoleState>) {
  }

  ngOnInit(): void {
    this.roleForm = this.fb.group({
      name: new FormControl<string>(this.role.name, [Validators.required, Validators.minLength(3), Validators.maxLength(30)]),
      description: new FormControl<string>(this.role.description, [Validators.required, Validators.minLength(1), Validators.maxLength(100)]),
      permissions: new FormControl<Array<PermissionDto>>(this.role.permissions, Validators.required)
    });

    this.subscriptions.push(
      this.roleStore.select(initPermissionSelector).subscribe((permissions) => {
        this.permissions = Object.values(permissions);
      })
    );
  }

  update(): void {
    const command: UpdateRoleCommand = {
      id: this.role.id,
      name: this.roleForm.value.name,
      permissionIds: this.roleForm.value.permissions.map(p => p.id),
      description: this.roleForm.value.description
    }
    this.subscriptions.push(
      this.roleService.updateRole(command).subscribe(() => {
        this.roleStore.dispatch(new UpdateRole({
          ...this.role,
          name: command.name,
          permissions: this.roleForm.value.permissions,
          description: this.roleForm.value.description
        }));
        this.modalRef.hide();
      })
    );
  }

  close(): void {
    this.modalRef.hide();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
